export default __webpack_public_path__ + "static/icon_heg-5419e8a80ce4a2851370e2d10cdff620.png";